import { entity } from '../../region.json';

const ENTITY_APP_STORE_LINKS = {
  GERMANY: {
    android: 'https://play.google.com/store/apps/details?id=eu.qwello.app',
    ios: 'https://apps.apple.com/us/app/qwello/id1499322729',
  },
  SWEDEN: {
    android: 'https://play.google.com/store/apps/details?id=eu.qwello.app',
    ios: 'https://apps.apple.com/se/app/qwello/id1499322729',
  },
  ITALY: {
    android: 'https://play.google.com/store/apps/details?id=eu.qwello.app',
    ios: 'https://apps.apple.com/it/app/qwello/id1499322729',
  },
  FRANCE: {
    android: 'https://play.google.com/store/apps/details?id=eu.qwello.app',
    ios: 'https://apps.apple.com/fr/app/qwello/id1499322729',
  },
  SPAIN: {
    android: 'https://play.google.com/store/apps/details?id=eu.qwello.app',
    ios: 'https://apps.apple.com/es/app/qwello/id1499322729',
  },
  UK: {
    android: 'https://play.google.com/store/apps/details?id=eu.qwello.app',
    ios: 'https://apps.apple.com/gb/app/qwello/id1499322729',
  },
  POLAND: {
    android: 'https://play.google.com/store/apps/details?id=eu.qwello.app',
    ios: 'https://apps.apple.com/pl/app/qwello/id1499322729',
  },
  NETHERLANDS: {
    android: 'https://play.google.com/store/apps/details?id=eu.qwello.app',
    ios: 'https://apps.apple.com/cz/app/qwello/id1499322729',
  },
};
export default ENTITY_APP_STORE_LINKS[entity];
